import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-435155bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ion-text-center",
  style: {"margin-top":"20%"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, "Digite o seu telefone Celular ou Whatsapp")
], -1))
const _hoisted_2 = { class: "ion-text-center" }
const _hoisted_3 = { class: "ion-text-center ion-margin-vertical" }

import { IonContent, IonLabel, loadingController , IonButton , alertController , IonGrid, IonRow, IonCol, IonInput, IonItem} from '@ionic/vue';
import { ref } from 'vue';
import { useStore } from 'vuex';
import { key } from '../store';
import { useRouter } from 'vue-router';
import {maskitoNumberOptionsGenerator} from '@maskito/kit';
import {maskito} from '@maskito/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutUser',
  setup(__props) {

const vMaskito = maskito;

const fone = ref('');

const store = useStore(key);
const router = useRouter();

const moptions = {
    mask:  ['(',/[0-9]/ , /[0-9]/ ,')',  /[0-9]/,  /[0-9]/,  /[0-9]/,  /[0-9]/,  /[0-9]/, '-',  /[0-9]/,  /[0-9]/,  /[0-9]/,  /[0-9]/]
    //mask: [ /\d/, /\d/, /\d/, /\d/,' ' ,/\d/, /\d/, /\d/, /\d/, /\d/],
 };

function cv(ev){
    // console.log('change value ', fone.value), ev;
}


async function showLoading(){
        const loading = await loadingController.create({
          message: 'Procurando...',
          duration: 3000,
          spinner: 'circles',
        });
        
        loading.present();
        loading.onWillDismiss().then(()=>{
            // console.log('end');
            if(store.state.user.status == 'notfound'){

                router.push({name: 'checkoutcliente'})
                
            } else {
                router.push({name: 'checkoutcliente'})
            }
            
        })
    }

const presentAlert = async () => {
    const alert = await alertController.create({
        header: 'Alerta',
        subHeader: 'Verifique o telefone',
        message: 'Digite um telefone válido com DDD',
        buttons: ['OK'],
    });

    await alert.present();
};

const userNotFound = async () => {
    const alert = await alertController.create({
        header: 'Cliente não localizado',
        subHeader: 'Verifique o telefone',
        message: 'Verifique o telefone digitado ou cadastre um novo cliente',
        buttons: [
            {
                text: 'Tentar novamente',
                role: 'cancel',
            }, 
            {
                text: 'Novo cliente',
                role: 'novo',
                handler: () => {
                    // console.log('novo cliente');
                    store.user
                    router.push({name: 'checkoutclientenovo'})
                }
            }
        ],
    });

    await alert.present();
};


async function searchUserFone(foneSrc: string){
    const foneSrcAlt = foneSrc.replace('(', '').replace(')', '').replace('-','') 
    // console.log('fone digitado', foneSrcAlt);

    if (foneSrcAlt == undefined || foneSrcAlt == '' || foneSrcAlt == null || foneSrcAlt.length < 11 ){
        presentAlert();
    } else {
        //showLoading();
        store.dispatch('getUserFone', {fone: foneSrcAlt, token: store.state.token.access_token}).then(ret=>{
            console.log('retorno user dispatch', ret);
            if(ret == 'notfound'){
                userNotFound();
            } else {
                router.push({name: 'checkoutcliente'})
            }
            
        })
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), null, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "fone",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fone).value = $event)),
                      placeholder: "(xx)xxxxx-xxxx",
                      inputmode: "numeric"
                    }, null, 512), [
                      [_vModelText, fone.value],
                      [_unref(vMaskito), moptions]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(IonButton), {
                      color: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (searchUserFone(fone.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Localizar cadastro")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})